import React, {useContext, useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import {Template1, Template2, Template3, Template4} from '../components/_index';
import {E404} from './404';
import withRouter from '../services/withRouter';
import Helper from '../services/Helper'
import {cvEng} from '../services/_templateData';
import CvMakerContext from '../services/app-context';

const Cv2 = ({}) => {

    let context = useContext(CvMakerContext);

    let style = {
        menu: {
            position: 'absolute',
            padding: '0px 0',
            background: 'white',
            borderRadius: '10px',
            border: '1px solid #c8c8c8',
            overflow: 'hidden',
            marginLeft: '-50px',
            marginTop: '6px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)'
        },
        las: {
            color: 'red',
            margin: '0 4px',
            fontSize: '24px'
        }
    };

    let [state, setState] = useState({
        error: false,
        loading: true,
        cv: cvEng
    })

    var id = 0;
    var fullName = "";
    const [searchParams, setSearchParams] = useSearchParams();
    

    useEffect(() => {

        var a = searchParams.keys();
        debugger
        id = searchParams.get("id");
        fullName = searchParams.get("fullName");
        alert(fullName);

        getCv(id, fullName);
    }, []);


    const getCv = async (id, fullName) => {
        setState({error: false, loading: true});
        const data = await Helper.callApiAsJson({
            url: `/resume/FindResume/${id}/${fullName}`, type: 'get'
        })

        if (data) {
            let resume = Helper.decode(data.text);
            setState({template: 0}, () => {
                document.title = resume.cv.fullName + "-CVMaker";
                setState({
                    template: resume.template,
                    cv: {...resume.cv, id: id}
                    , loading: false
                });
            });

            setTimeout(() => {
                document.querySelectorAll('[contenteditable="true"]')
                    .forEach(b => b.removeAttribute('contenteditable'));
            }, 1000);
        } else
            setState({error: true, loading: false});
    }

    const printCv = () => {
        //document.getElementById('toollbar').classList.add('d-none');
        window.print()
        //document.getElementById('toollbar').classList.remove('d-none');

        //var divContents = document.getElementById("GFG").innerHTML;
        //var head = document.getElementsByTagName('head')[0].innerHTML;
        //debugger;
        //var a = window.open('', '', 'height=500, width=500');
        //a.document.write('<html>');
        //a.document.write('<head>' + head + '<style></style>' + '</head>');
        //a.document.write('<body >');
        //a.document.write(divContents);
        //a.document.write('</body></html>');
        //a.document.close();
        //a.print();
    }


    return (
        <>
            <button onClick={() => {
                printCv()
            }}
                    style={{position: 'fixed', top: '14px', zIndex: '30', margin: '0 14px'}}
                    className="btn btn-dark btn-sm">{context.lang.print} <i className="las la-print"></i></button>


            <div id="GFG" className={`${state.cv.rtl ? 'rtl' : 'ltr'} bg-white a4 text-center`}
                 style={{
                     marginLeft: 'auto',
                     marginRight: 'auto',
                 }}>
                {state.loading && <div>loading....</div>}
                {state.error && <E404></E404>}
                {state.template == 1 && <Template1 cv={state.cv} readonly/>}
                {state.template == 2 && <Template2 cv={state.cv} readonly/>}
                {state.template == 3 && <Template3 cv={state.cv} readonly/>}
                {state.template == 4 && <Template4 cv={state.cv} readonly/>}
                {state.template == 4 && <Template4 cv={state.cv} readonly/>}
            </div>

        </>
    );

}
export const CvWithRouter2 = withRouter(Cv2);